module.exports = __webpack_public_path__ + "img/paypal.4868b638.svg";